export default {"src":"/_next/static/media/material_data_breakdown_for_strategic_clarity.43e7335a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};